// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixData from 'wix-data';
import { getPostsByCategory } from 'backend/postsFetcher';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

const isDesktop = (wixWindow.formFactor === "Desktop") ? true : false;

async function getPostData() {
	
	// Get the current post object
	const post = await ($w('#post1').getPost());
	
	let postItem;

	// Set post title
	$w('#postTitle').text = post.title;
	$w('#postTitle').show();

	// Set post title
	$w('#postExcerpt').text = post.excerpt;
	$w('#postExcerpt').show();

	// Set post date (format it as "<month> <dd>, <yyyy>")
	var options = { year: 'numeric', month: 'long', day: 'numeric' };
	$w('#postPublishDate').text = post.publishedDate.toLocaleDateString('en-US', options);
	if (isDesktop) {
		$w('#postPublishDateLabel').show();
	}

	$w('#postPublishDate').show();

	// Get the current post's extra info from the additional collection
	// There should be only one entry per post, as we cannot force it in the collection we need to limit results to 1
	let extraPostsInfoResults = await wixData.query('Extra_Post_Info')
		.include("mainCategory", "tags")
		.eq('post', post._id)
		.limit(1)
		.find();

	if (extraPostsInfoResults.items.length > 0) {
		postItem = extraPostsInfoResults.items[0];

		// Set main category
		$w('#postMainCategoryButton').label = postItem.mainCategory.title;
		$w('#postMainCategoryButton').link = postItem.mainCategory['link-categories-all'];
		$w('#postMainCategoryButton').show();

		// Set post hero image / video (using gallry cause strip is not responsive)
		let type = ('postPageVideo' in postItem) ? "video" : "image";
		let src = ('postPageVideo' in postItem) ? postItem.postPageVideo : postItem.postPageImage;
		$w("#postGalleryCover").items = [{
			"type": type,
			"src": src
		}];
		$w("#postGalleryCover").show();

		// Set post author 
		$w('#postAuthor').text = postItem.author;
		$w('#postAuthorLabel').show();
		$w('#postAuthor').show();

		// Set post illustrator (not a mandatory field)
		if ('illustrator' in postItem) {
			$w('#postIllustratorLabel').show()
			$w('#postIllustrator').text = postItem.illustrator;
			$w('#postIllustrator').show();
			$w('#postIllustratorLabel').show();
		}

		if ('tags' in postItem && postItem.tags.length > 0) {
			let postTagData = postItem.tags[0];
			$w('#postTagButton').label = postTagData.title;
			$w('#postTagButton').link = postTagData['link-tags-title'];
			$w('#postTagButton').show();
		}

		if (isDesktop) {
			$w('#line1').show();
		}

		$w('#line2').show();
	}

	// Set the related articles section 
	let relatedArticlesData = await getPostsByCategory(postItem.mainCategory._id, 6);
	$w('#relatedArticlesRepeater').data = relatedArticlesData.filter(o => o._id !== post._id);
	$w('#relatedArticlesRepeater').show();
}

function articlesRepeaterItemReadyHandler($item, itemData, index) {

	// Set title
	$item('#relatedArticleTitle').text = itemData.title;

	// Set image
	$item('#relatedArticleImage').src = itemData.coverImage;
	$item('#relatedArticleImage').link = itemData.postPageUrl;

	// Set category
	$item('#relatedArticleMainCategoryButton').link = itemData.mainCategory['link-categories-all'];
	$item('#relatedArticleMainCategoryButton').label = itemData.mainCategory.title;

	// Set excerpt
	if (isDesktop) {
		$item('#relatedArticleExcerpt').text = itemData.excerpt;
		$item('#relatedArticleExcerpt').show();
	}

	// Set button
	$item('#relatedArticleButton').link = itemData.postPageUrl;
	$item('#relatedArticleButtonTitle').link = itemData.postPageUrl;

}

function postInfoRepeaterItemReadyHandler($item, itemData, index) {

	// Set title
	$item('#text').text = itemData.text;

}

$w.onReady(function () {

	$w('#relatedArticlesRepeater').onItemReady(articlesRepeaterItemReadyHandler);

	try {
		getPostData();
	} catch (e) {
		console.log('Error while trying to get post data: ' + JSON.stringify(e));
	}

	wixLocation.onChange(async (location) => {
		try {
			await getPostData()
		} catch (e) {
			console.log('Error while trying to get post data: ' + JSON.stringify(e))
		}
	})

});

export function relatedArticleBox_mouseIn(event) {
	if (isDesktop) {
		let $item = $w.at(event.context);
		$item("#relatedArticleBoxHover").show();
		$item("#relatedArticleImage").hide();
		$item("#relatedArticleExcerpt").show();
	}

}

export function relatedArticleBox_mouseOut(event) {
	if (isDesktop) {
		let $item = $w.at(event.context);
		$item("#relatedArticleBoxHover").hide();
		$item("#relatedArticleImage").show();
		$item("#relatedArticleExcerpt").hide();
	}

}